import RegistrationProvider from './RegistrationContext';
import Registration from './Registration';

let Index = () => {
    return (
        <RegistrationProvider>
            <Registration />
        </RegistrationProvider>
    )
}

export default Index;